"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return UpdatePost;
    }
});
var _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function UpdatePost(_param) {
    var title = _param.title, props = _objectWithoutProperties(_param, [
        "title"
    ]);
    return /*#__PURE__*/ _react.createElement("svg", _extends({
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": !!title
    }, props), title ? /*#__PURE__*/ _react.createElement("title", null, title) : null, /*#__PURE__*/ _react.createElement("path", {
        d: "M6 7L14 7",
        stroke: "#384241",
        strokeWidth: "2"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M6 11L11 11",
        stroke: "#384241",
        strokeWidth: "2"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M6 15H10",
        stroke: "#384241",
        strokeWidth: "2"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M10 19H3V3H17V9",
        stroke: "#384241",
        strokeWidth: "2",
        strokeLinejoin: "bevel"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M13.1289 15C13.5729 13.275 15.1389 12 17.0029 12C18.4829 12 19.7749 12.804 20.4669 13.999",
        stroke: "#384241",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M22.2214 11.6484L21.7934 15.9994L17.5234 15.0604L22.2214 11.6484Z",
        fill: "#384241"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M20.8771 18C20.4331 19.725 18.8671 21 17.0031 21C15.5231 21 14.2311 20.196 13.5391 19.001",
        stroke: "#384241",
        strokeWidth: "2",
        strokeMiterlimit: "10"
    }), /*#__PURE__*/ _react.createElement("path", {
        d: "M11.7812 21.351L12.2093 17L16.4793 17.939L11.7812 21.351Z",
        fill: "#384241"
    }));
}

//# sourceMappingURL=UpdatePost.js.map